/* eslint-disable */
// this is an auto generated file. This will be overwritten

export var createUsers = "mutation CreateUsers($input: CreateUsersInput!) {\n  createUsers(input: $input) {\n    email\n    mapOptions\n  }\n}\n";
export var updateUsers = "mutation UpdateUsers($input: UpdateUsersInput!) {\n  updateUsers(input: $input) {\n    email\n    mapOptions\n  }\n}\n";
export var deleteUsers = "mutation DeleteUsers($input: DeleteUsersInput!) {\n  deleteUsers(input: $input) {\n    email\n    mapOptions\n  }\n}\n";